export default __webpack_public_path__ + "1.19.4/static/media/LibreDataShare.42dcc986.svg";